__turbopack_context__.v({
  "inner": "index-module__uJMRBq__inner",
  "label": "index-module__uJMRBq__label",
  "loader": "index-module__uJMRBq__loader",
  "root": "index-module__uJMRBq__root",
  "section": "index-module__uJMRBq__section",
});
